import React, { ChangeEvent } from "react";
import * as app from "../services/AppService";
import Button from "../components/Button";
import { KeyValue } from "../models/Core/key-value";
import { RowItem } from "../models/Core/row-item";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";
export interface SelectProps extends RowItem, InterfaceComponentsProps {
    onChange?: (selected: string, arr: KeyValue[] | any[], SelectID?: string) => void,
    model: string | number,
    onBlur?: (newValue: string) => void,
    elmKey?: string,
    required?: boolean,
    selectdObjectChange?: (selected:any)=>void,
    options: KeyValue[] | any,
    iconClicked?: () => void,
    containerClass?: string,
    value?: any,
    colsize?: string;
} 

function Select(props: SelectProps) { 
    function handler(event: ChangeEvent<HTMLSelectElement>) {
        const { value } = event.target;
        if (props.selectdObjectChange) {
            var selected = props.options.find((r: any) => r[props.elmKey!] + '' === value + '');
            props.selectdObjectChange(selected);
        }
        else if (props.onChange && typeof props.onChange == "function")            
                props.onChange(value, props.options, props.id);
    }
    function OnBlurhandler(event: ChangeEvent<HTMLSelectElement>) {
        const { value } = event.target;
        if (props.onBlur && typeof (props.onBlur) === "function")
            props.onBlur(value);
    }
    function icon_clicked() {
        if (props.iconClicked)
            props.iconClicked()
    }

    let select = (<select
        className={`form-select form-select-sm rounded ${props.required && !props.model ? " is-invalid  border-1" : " border border-0 " + props.class}`}
        disabled={props.disabled}
        required={props.required && !props.model}
        onChange={handler}
        onBlur={OnBlurhandler}
        id={props.id ? props.id : "slct" + props.label}
        value={props.model}>

        {props.options && props.options.find((item: any)   => +item[props.elmKey!] === 0 || item[props.elmKey!] + '' !== props.model + '') === undefined && (
        <option defaultValue="0" disabled={true} value="0"></option>
        )}
        {props.options && props.options.find((item: any) => item[props.elmKey!] + '' === props.model + '') === undefined && (
            <option defaultValue={props.model} disabled={true} value={props.model}></option>
        )}

        {(props.options || []).map((item: any) => {
            return (
                <option key={item[props.elmKey!]} value={item[props.elmKey!]}>
                    {typeof (props.value) == "function" ? props.value(item) : item[props.value||'']}
                </option>
            );
        })}
    </select>)
    return (props.isTable ? select :
        <div className={props.containerClass}>
                        {props.label && (
                <label className={props.labelClass}>{app.translate(props.label)}</label>
            )}
            <div className={`border rounded bg-light-subtle input-group `} >
                {select }
                {props.icon &&
                    <Button icon={props.icon} class="text-primary rounded-end rounded-1  " clicked={icon_clicked} />
                }
            </div>
        </div>

    );
}

Select.defaultProps = {
    class: " ",
    elmKey: "Key",
    value: "Value",
    labelClass: "fw-semibold text-primary-emphasis ",
    disabled: false,
    required: false,
    containerClass: " mt-1",
    isTable: false,
    label:""
};

export default Select;
